module.exports = __webpack_public_path__ + "assets/imgs/logos/raif.936a9cdd21e1b11ee57de010a666eaf0.svg";